module.exports = __webpack_public_path__ + "media/images/icons/filled/reddit-square-310e5891a72c14b89852c8ef2dbf49ed.svg";